Object.defineProperty(exports, '__esModule', {
  value: true,
});
const warn = function warn(s) {
  console.warn('[react-gtm]', s);
};

exports.default = warn;
